//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngOssClearing', srsngOssClearing);

    function srsngOssClearing($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/oss-clearing/oss-clearing.html',
            scope: {
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

